import { render, staticRenderFns } from "./CompactArticleList.vue?vue&type=template&id=42a9bc7d&"
import script from "./CompactArticleList.vue?vue&type=script&lang=js&"
export * from "./CompactArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports